/**
 * This View loads an iframe into it, displaying the iframe title and URL in
 * the chatbox header.
 * The iframe can ask the chatbox to close it by sending the
 * `asktech_iframe_close` message to its parent frame.
 * Ex: `window.parent.postMessage('asktech_iframe_close')`
 */
Views.add(new class extends AbstractView {

  constructor() {
    super({
      name: 'iframe',
      overlay: true
    });

    this._widgetSize = "small";
    this._mainTitle  = "";
    this._smallTitle = "";
    this._iframe = null;
    this._messageHandlerRef = null;
  }

  onActive() {
    let url = this.getState();
    const isDailyVideo = this.app._isVideoChatUrl(url) || (url && url.indexOf('videochat_join_guest') !== -1);

    // If a Daily iframe is already present, do not rebuild/replace it when reopening the chat
    if (isDailyVideo && this._iframe && this._iframe.isConnected) {
      // Keep existing iframe and titles
      Views.syncTitle();
      return;
    }

    if (this.app._isHelpCenterUrl(url) || this.app._isMeetingsUrl(url)) {
      const params = Utils.getUrlParams(url);
      // Auth parameters, equivalent to parameters in Ajax.init
      params.key        = this.app.getPublicKey();
      params.token      = this.app.getGuestToken();
      params.guest_hash = this.app._guest_hash;
      params.iframe     = "true";
      url = Utils.setUrlParams(url, params);
    }

    if (!url.includes('videochat_join_guest') && !this.app._isVideoChatUrl(url)) {
      Dom.setWidgetSize('large', () => {})
    }

    this.setContent(`
      <div class="slaask-loader-wrapper with-margins">
        <div class="slaask-loader-object slaask-loader-object-color slaask-loader-center" style="border-top-color: ${this.app._window_color}"></div>
      </div>`);

    const windowMessageHandler = event => {
      if (event.data && event.data.action == 'dailyco-redirect') {
        if (this.app._isVideoChatUrl(event.data.url)) {
          // Views.jumpToViewByName('video-chat', event.data.url);
        }
      }
      if (event.data === 'asktech_iframe_close' || (event.data && event.data.action === 'asktech_iframe_close')) {
        // Explicit close requested by the iframe content
        this.setContent('');
        Dom.get('widget').window.removeEventListener('message', windowMessageHandler);
        Views.jumpToPrevious(false);
      }
    };
    // Attach message handler once
    if (!this._messageHandlerRef) {
      this._messageHandlerRef = windowMessageHandler;
      Dom.get('widget').window.addEventListener('message', this._messageHandlerRef);
    }

    this.once('leave', () => {
      // Do not tear down Daily video on simple view leave (e.g., closing chat)
      if (!isDailyVideo) {
        this.setContent('');
        if (this._messageHandlerRef) {
          Dom.get('widget').window.removeEventListener('message', this._messageHandlerRef);
          this._messageHandlerRef = null;
        }
      }
    });

    this._iframe = Dom.get('widget').document.createElement('iframe');
    this._iframe.allow = 'camera *; microphone *; display-capture *';
    this._iframe.addEventListener('load', () => {
      let loader = this.element.querySelector('.slaask-loader-wrapper');
      if (loader) loader.parentElement.removeChild(loader);
    });

    this._iframe.src = url;
    this.element.appendChild(this._iframe);

    this._mainTitle = this._smallTitle = "";
    Views.syncTitle();
    Previewer.oembedRequest(url).then(linkData => {
      this._mainTitle = linkData.title;
      this._smallTitle = linkData.description;
      Views.syncTitle();
    });
  }

  mainTitle() { return this._mainTitle; }

  smallTitle() { return this._smallTitle; }

  initEventListeners() {
  }

  _htmlBase() {
    return '';
  }

});
